import Home from "./components/Home";
import NavBar from "./components/NavBar";
// import About from "./components/About";
import SocialLinks from "./components/SocialLinks";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Skills from "./components/Skills";
// import Portfolio from "./components/Portfolio";

function App() {
  return (
    <div>
      <NavBar />
      <Home />
      {/* <About /> */}
      <Skills />
      <Experience />
      <Education />
      {/* <Portfolio /> */}
      <SocialLinks />
    </div>
  );
}

export default App;
